import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import Image from 'next/image'
import { RegularSection, ColorTitle } from '@/components/Layouts'

const TEXT_GRID_SX = {
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
  justifyContent: 'center',
}

const IMAGE_GRID_SX = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: 5,
  overflow: 'hidden',
}

interface ImageData {
    src?: string
    alt?: string
}

interface Content {
    title?: string
    text?: string
    image?: ImageData
}

interface S3_L3_3Props {
    content?: Content
    blockName?:string
}

const Index = (props: S3_L3_3Props) => {
    const { content = {} } = props
    const { title = '', text = '', image = {} } = content
    return (
        <RegularSection aria-label='S3_L3_3' >
            <Grid
                container
                spacing={4}
                sx={{ width: '100%' }}
            >

                <Grid
                    size={{ xs: 12, md: 6, lg: 7 }}
                    sx={TEXT_GRID_SX}
                >
                    <ColorTitle title={title} colorFrom={0} textAlign='start' width='100%'/>
                    <Typography variant='body2'>{text}</Typography>
                </Grid>
                <Grid
                    size={{ xs: 12, md: 6, lg: 5 }}
                    sx={IMAGE_GRID_SX}
                >
                    <Image
                        src={image.src || '/img/img-160400.jpg'}
                        alt={image.alt || 'man cutting concrete'}
                        width={670}
                        height={360}
                        style={{ objectFit: 'cover', width: '100%', height: 'auto' }}
                    />
                </Grid>
            </Grid>
        </RegularSection>
    )
}

export default Index
